import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FacetedSearchConfigurator from '../Components/FacetedSearchConfigurator';
import { query, submitSearchFacet, toggleVisibleDropdownMenu, searchFacetChange, searchFacetUpdate, searchFacetRefresh } from '../Actions/FacetedSearch.action';
import { setSelectedTyre } from '../Actions/Cart.action'
import { translate } from '../Services/translation';
import { PRODUCT_VIEW_CACHED, updateFilterOption } from '../Actions/FacetedSearch.action';
import { setCarPriceList } from '../Actions/CarPriceLists.action';
import ConfiguratorSummary from '../Components/ConfiguratorSummary';
import ProductListSlider from '../Components/ProductListSlider';
import TyresFilter from '../Components/TyresFilter';
import StickyDetails from '../Components/StickyDetails';


class FacetedSearchConfiguratorContainer extends Component {
    constructor(props) {
        super(props);
        const { facetFilters } = props;
        this.state = {
            facetFilters,
        };
    }

    componentDidMount() {
        let usedCarId = this.props.usedCarProductId ? this.props.usedCarProductId : '';
        this.props.query(window.location.search.substr(1) || '', true, usedCarId);
    }

    onFacetChange(filter, option) {
        this.setState((prevState, props) => {
            const { facetFilters } = this.state;
            const newFilters = updateFilterOption(facetFilters, filter, option);
            return {
                ...prevState,
                facetFilters: newFilters,
            };
        });
    }

    static getDerivedStateFromProps(nextProp, prevState) {
        if (nextProp.productsViewCachedId !== prevState.productsViewCachedId) {
            return {
                ...prevState,
                ...nextProp,
            }
        }
        return prevState;
    }

    onSearchResultDataChange(dom) {
        if ([null, undefined].includes(dom)) {
            return;
        }
        const container = document.createElement('div');
        container.innerHTML = dom;
        const existingResult = document.querySelector("#search-result");
        const tempResult = container.querySelector("#search-result");
        const existingFilter = document.querySelector('#facetedSearchConfigurator');
        const tempFilter = document.querySelector('#facetedSearchConfigurator');
        const replace = (node, newNode) => node.parentNode.replaceChild(newNode, node);


        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter);
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult);
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents();

    }

    componentDidUpdate() {

        const productViewCached = window.__litium.cache ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {} : {};
        if (!productViewCached.used) {
            productViewCached.used = true;
            const dom = productViewCached.productsView;
            dom && this.onSearchResultDataChange(dom);
        }
    }

    render() {
        const {
            subNavigation,
            sortCriteria,
            navigationTheme = '',
            ...facetProps
        } = this.props;

        const { facetFilters } = this.state;
        const facetState = {
            ...facetProps,
            facetFilters,
            onFacetChange: (filter, option) => this.onFacetChange(filter, option),
        };
        const empty = array => !(array && array.length);
        const subNavigations = !subNavigation ? null : [subNavigation];
        const sortCriterias = !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;
        const hidden = [subNavigations, facetFilters, sortCriterias].every(arr => empty(arr));

        const setPriceListAndUpdate = (priceList) => {
            const { facetFilters } = this.state;
            this.props.setCarPriceList(priceList).then(result => {
                this.props.searchFacetRefresh();
            });
        }

        let { tyres } = this.props;


        let selectedTyreId = "";

        if (this.props.product && this.props.product.tyre) {
            selectedTyreId = this.props.product.tyre.id;

        }

        const setSelectedTyreAndUpdate = (tyre) => {
            const { facetFilters } = this.state;
            this.props.setSelectedTyre(tyre).then(result => {
                this.props.searchFacetChange(facetFilters)
            });
        }

        const productTypeId = this.props.product ? this.props.product.productTypeId : null;

        return hidden ? null :
            <Fragment>
                {productTypeId !== 'UsedCars' &&
                    <Fragment>
                        <FacetedSearchConfigurator {...this.props} />
                        {tyres && tyres.length > 0 &&
                            <div className="faceted-search__item">
                                <div className="faceted-search">
                                    <ul className="faceted-search__group" ref="list">
                                        <div className="faceted-search__group-header" role="faceted-search-item-group">{translate('configuration.tyreheader')}</div>
                                        {tyres && tyres.map((tyre, index, arr) =>
                                            <li key={`${index}-${tyre.quantityFieldId}`} className="faceted-search__item" role="faceted-search-item">
                                                <TyresFilter allTyres={tyres} tyre={tyre} selectedTyreId={selectedTyreId} setSelectedTyre={setSelectedTyreAndUpdate} />
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        }

                        <ConfiguratorSummary
                            carParts={this.props.carParts}
                            product={this.props.product}
                            carPriceLists={this.props.carPriceLists}
                            setCarPriceList={setPriceListAndUpdate}
                        />
                        <StickyDetails product={this.props.product} priceLists={this.props.carPriceLists} />
                    </Fragment>
                }

                <div className="configurator-related-products">
                    {this.props.relatedAccessoriesViews && this.props.relatedAccessoriesViews.length > 0 &&
                        <ProductListSlider header={translate('product.accessories')} subheader={translate('product.availableoncarpurchase')} values={this.props.relatedAccessoriesViews} />
                    }
                    {this.props.relatedServicesViews && this.props.relatedServicesViews.length > 0 &&
                        <ProductListSlider header={translate('product.services')} subheader={translate('product.availableoncarpurchase')} values={this.props.relatedServicesViews} />
                    }
                </div>
            </Fragment>
            ;
    }
}

const mapStateToProps = state => {
    const {
        facetedSearch: {
            subNavigation,
            sortCriteria,
            facetFilters,
            visibleDropdownMenu,
            navigationTheme,
            productsViewCachedId,
            relatedAccessoriesViews,
            relatedServicesViews,
            product,
            tyres
        },
        cart: { selectedTyreId },
        configurator: { usedCarProductId, carPriceLists }
    } = state;
    return {
        usedCarProductId,
        carPriceLists,
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
        product,
        tyres,
        relatedAccessoriesViews,
        relatedServicesViews,
        selectedTyreId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        query: (q, withHtmlResult, usedCarId) => dispatch(query(q, withHtmlResult, usedCarId)),
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
        toggleVisibleDropdownMenu: (group) => dispatch(toggleVisibleDropdownMenu(group)),
        searchFacetChange: (group, item) => dispatch(searchFacetChange(group, item)),
        searchFacetUpdate: (group, item) => dispatch(searchFacetUpdate(group, item)),
        searchFacetRefresh: () => dispatch(searchFacetRefresh()),
        setCarPriceList: (priceList) => dispatch(setCarPriceList(priceList)),
        setSelectedTyre: (selectedTyreId) => dispatch(setSelectedTyre(selectedTyreId)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacetedSearchConfiguratorContainer);